import { Reveal, Overline } from "@/components/Reveal";

const PORTRAIT_IMG = "/images/sergio-portrait.webp";

const chapters = [
  {
    num: "01",
    title: "The problem was never you.",
    body: "That's not a character flaw — it's a skill gap nobody ever taught you to close.",
  },
  {
    num: "02",
    title: "Confidence is trainable.",
    body: "I ran over a thousand first dates and turned what worked into a repeatable system.",
  },
  {
    num: "03",
    title: "Reps beat theory. Every time.",
    body: "No scripts, no manipulation — live reps and honest feedback until it's actually yours.",
  },
  {
    num: "04",
    title: "Private. Direct. Built around you.",
    body: "1-on-1, discreet, tailored to your life. Eight weeks is the average transformation.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="border-t border-white/10" data-testid="manifesto-section">
      <div className="mx-auto max-w-5xl px-6 py-28 text-center lg:px-10 lg:py-40">
        <Reveal>
          <Overline>The Manifesto</Overline>
          <h2 className="mx-auto mt-6 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            Four truths about dating <span className="italic text-neutral-400">nobody tells professional men.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:mt-28 lg:gap-16">
          {chapters.map((c) => (
            <Reveal key={c.num} delay={0.05}>
              <div className="flex flex-col items-center border-t border-white/10 pt-10" data-testid={`manifesto-chapter-${c.num}`}>
                <span className="font-serif text-sm font-light text-white/30">{c.num}</span>
                <h3 className="mt-4 font-serif text-2xl font-light tracking-tight sm:text-3xl">{c.title}</h3>
                <p className="mx-auto mt-4 max-w-sm text-base leading-relaxed text-neutral-400">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 flex flex-col items-center lg:mt-28">
          <div className="mx-auto w-40 overflow-hidden border border-white/10">
            <img
              src={PORTRAIT_IMG}
              alt="Sergio Chavez — private dating consultant"
              className="aspect-[3/4] w-full object-cover grayscale transition-all duration-700 hover:grayscale-0"
              data-testid="manifesto-portrait"
            />
          </div>
          <Overline className="mt-8">Sergio Chavez</Overline>
          <p className="mx-auto mt-6 max-w-xl font-serif text-2xl font-light italic leading-snug text-neutral-200 sm:text-3xl">
            "I don't teach men to become someone else. I teach them to stop
            hiding the man they already are."
          </p>
          <p className="mt-8 text-xs uppercase tracking-[0.3em] text-neutral-500">
            Private Dating Consultant — @sergjchavez
          </p>
        </Reveal>
      </div>
    </section>
  );
}
